export const useDummyDigestOrderItems = false;

export const flowDigestOrderItems = [
    {
        id: 1,
        sku: "SPGC2323",
        name: "Spotify Gift Card (RM50)",
        quantity: 1,
        unit_price: 50,
        amount: 50,
        tax_code: "SV6",
        tax_amount: 9,
        created_at: "2023-11-23 22:04:03",
        updated_at: "2023-11-23 22:04:03",
    },
    {
        id: 2,
        sku: "10VCN839",
        name: "Huhhh",
        quantity: 2,
        unit_price: 22,
        amount: 44,
        tax_code: "SV6",
        tax_amount: 1.56,
        created_at: "2023-11-23 22:04:03",
        updated_at: "2023-11-23 22:04:03",
    },
    {
        id: 3,
        sku: "10VCN845",
        name: "OKOk",
        quantity: 10,
        unit_price: 4.3,
        amount: 43,
        tax_code: "SV6",
        tax_amount: 9,
        created_at: "2023-11-23 22:04:03",
        updated_at: "2023-11-23 22:04:03",
    },
];
